import { IFormSchema } from '@ninja/utilities';
import { QuotePlanSchema } from '../../server/map-quotes';
import {
	QuoteFiltersFromUrl,
	useConsultationCoPay,
	useDiagnosticCoPay,
	useInitialValuesFromUrl,
	useInsuranceCompaniesField,
	usePharmacyCoPay,
	usePlanKeyBenefits,
	usePlanNetworkGroups,
} from './helpers';

export type QuoteFilters = {
	insurerCompanyId?: number;
	opConsultationCoPaymentId?: string[];
	networkId?: number[];
	pharmacyCoPaymentId?: string[];
	diagnosticCoPaymentId?: string[];
	keyBenefitId?: number[];
	investorOrPartner?: number;
};

export const useQuoteFilterSchema = ({
	originalQuotes,
	initialValuesFromUrl,
}: {
	originalQuotes: QuotePlanSchema[];
	initialValuesFromUrl: QuoteFiltersFromUrl;
}) => {
	const { getInsuranceCompaniesField } = useInsuranceCompaniesField(originalQuotes);
	const { getConsultationCopay } = useConsultationCoPay(originalQuotes);
	const { getDiagnosticCoPay } = useDiagnosticCoPay(originalQuotes);
	const { getPharmacyCopay } = usePharmacyCoPay(originalQuotes);
	const { getNetworkGroups } = usePlanNetworkGroups(originalQuotes);
	const { getKeyBenefits } = usePlanKeyBenefits(originalQuotes);
	const { filterInitialValues } = useInitialValuesFromUrl(initialValuesFromUrl);

	const schema: IFormSchema<QuoteFilters> = {
		fields: [
			getInsuranceCompaniesField,
			getConsultationCopay,
			getPharmacyCopay,
			getKeyBenefits,
			getDiagnosticCoPay,
			getNetworkGroups,
		],
		initialValues: filterInitialValues ?? {},
	};

	return { schema };
};
